import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useLayoutEffect, mergeProps } from '@react-aria/utils';
import ariaHideOutside from './aria-hide-outside.esm.js';
import useOverlay from './use-overlay.esm.js';
import useOverlayPosition from './use-overlay-position.esm.js';
import usePreventScroll from './use-prevent-scroll.esm.js';

var _excluded = ["triggerRef", "popoverRef", "isNonModal", "isKeyboardDismissDisabled", "shouldCloseOnInteractOutside", "isDismissable"];

/**
 * Provides the behavior and accessibility implementation for a popover component.
 * A popover is an overlay element positioned relative to a trigger.
 */
function usePopover(props, state) {
  var triggerRef = props.triggerRef,
    popoverRef = props.popoverRef,
    isNonModal = props.isNonModal,
    isKeyboardDismissDisabled = props.isKeyboardDismissDisabled,
    shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside,
    isDismissable = props.isDismissable,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useOverlay = useOverlay({
      isOpen: state.isOpen,
      onClose: state.close,
      shouldCloseOnBlur: true,
      isDismissable: isDismissable || !isNonModal,
      isKeyboardDismissDisabled: isKeyboardDismissDisabled,
      shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, popoverRef),
    overlayProps = _useOverlay.overlayProps,
    underlayProps = _useOverlay.underlayProps;
  var _useOverlayPosition = useOverlayPosition(_objectSpread2(_objectSpread2({}, otherProps), {}, {
      targetRef: triggerRef,
      overlayRef: popoverRef,
      isOpen: state.isOpen,
      onClose: isNonModal ? state.close : undefined
    })),
    positionProps = _useOverlayPosition.overlayProps,
    arrowProps = _useOverlayPosition.arrowProps,
    placement = _useOverlayPosition.placement;
  usePreventScroll({
    isDisabled: isNonModal || !state.isOpen
  });
  useLayoutEffect(function () {
    if (state.isOpen && !isNonModal && popoverRef.current) {
      return ariaHideOutside([popoverRef.current]);
    }
    return;
  }, [isNonModal, state.isOpen, popoverRef]);
  return {
    popoverProps: mergeProps(overlayProps, positionProps),
    arrowProps: arrowProps,
    underlayProps: underlayProps,
    placement: placement
  };
}

export { usePopover as default };
//# sourceMappingURL=use-popover.esm.js.map
